// @flow

import * as React from 'react';
import cx from 'classnames';
import { compose, isNil } from 'ramda';
import Input from '../../../basic-components/input';
import withFiltersContext from '../with-filters-context';
import withLabel from '../with-label';
import type { RangeValueT } from '../typings';

import cs from './styles.pcss';

type PropsT = {
  id: string,
  onChange: (?RangeValueT, string) => void,
  float?: boolean,
  placeholder?: ?{ min: ?string, max: ?string },
  value: RangeValueT,
  isMobile?: boolean,
  adaptive?: boolean,
};

const getValue = (value, key) =>{
 return value && typeof value === 'object' && !isNil(value[key]) ? value[key] : '';}

const getPlaceholder = (placeholder, key) =>{
  return placeholder && typeof placeholder === 'object' && placeholder[key];

}
  

const handleChange= (onChange, currentValue, key, shouldBeFloat,nullWhenEmpty=true)=> {
  return  (e) => {
    const value = currentValue ? { ...currentValue } : {};
    const parser = shouldBeFloat
      ? (v) => {
          if (v === null) {
            return null;
          }
  
          return parseFloat(v);
        }
      : (v) => {
          if (v === null) {
            return null;
          }
  
          return parseInt(v, 10);
        };
  
    if (e.target.value) {
      // console.log(1)
      value[key] = parser(e.target.value);
    } else {
      // console.log(2)
      delete value[key];
    }
  
    // it fixes broken query if only one key is provided
    if (value.min === undefined) {
      // console.log(3)
      if(nullWhenEmpty){
        value.min = null;
      }else{
        value.min = "";
      }
    }
  
    if (value.max === undefined) {
      // console.log(4)
      if(nullWhenEmpty){
        value.max = null;
      }else{
        value.max = "";
      }
    }
    // console.log("🚀 ~ file: index.js:73 ~ handleChange:", value,
    //   "Object.keys(value).length------",Object.keys(value).length,
    //   "e.target.value------",e.target.value)
    onChange(Object.keys(value).length ? value : null, e.target.value);
  };
}
const handleChange2=(onChange, currentValue, key, shouldBeFloat)=>{return handleChange(onChange, currentValue, key, shouldBeFloat,false)}

function RangeField({
  id,
  onChange,
  placeholder,
  value,
  float = false,
  isMobile,
  handleChangeFunc=handleChange,
  adaptive,
  ...restProps
}: PropsT) {
  return (
    <div className={cs.range}>
      {/* <h5 style={{color:'greenyellow'}}>placeholder:{JSON.stringify(placeholder)}</h5> */}
      {/* $FlowFixMe */}
      <Input
        className={cx(cs.from, { [cs.fromInModal]: isMobile && adaptive })}
        size={isMobile && adaptive ? 'medium' : 'small'}
        {...restProps}
        id={id}
        placeholder={getPlaceholder(placeholder, 'min')}
        onChange={handleChangeFunc(onChange, value, 'min', float)}
        value={getValue(value, 'min')}
      />
      <div className={cs.delimiter} />
      {/* $FlowFixMe */}
      <Input
        className={cx(cs.to, { [cs.toInModal]: isMobile && adaptive })}
        size={isMobile && adaptive ? 'medium' : 'small'}
        {...restProps}
        placeholder={getPlaceholder(placeholder, 'max')}
        onChange={handleChangeFunc(onChange, value, 'max', float)}
        value={getValue(value, 'max')}
      />
    </div>
  );
}

// $FlowFixMe
export default compose(withLabel, withFiltersContext)(RangeField);


export function RangeFieldWithNoLabel({...props}) {
  return (
    <RangeField handleChangeFunc={handleChange2} {...props}></RangeField>
  )
}
